module.exports = __webpack_public_path__ + "OpenSans-Bold.3326e4d74d3924ee1c88.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/Bold/OpenSans-Bold.woff2
// module id = ../../../../npm-font-open-sans/fonts/Bold/OpenSans-Bold.woff2
// module chunks = styles